var _defs, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.66671,
    height: 26.66671,
    viewBox: "0 0 26.66671 26.66671",
    fill: "none",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2144_176209",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#d9d9d9",
    id: "rect1",
    x: 0,
    y: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2144_176209)",
    id: "g1",
    transform: "translate(-2.66699,-2.66669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 20.667,14.6667 c 0.5555,0 1.0278,-0.1945 1.4167,-0.5833 0.3888,-0.3889 0.5833,-0.8612 0.5833,-1.4167 0,-0.5556 -0.1945,-1.0278 -0.5833,-1.4167 -0.3889,-0.3889 -0.8612,-0.5833 -1.4167,-0.5833 -0.5556,0 -1.0278,0.1944 -1.4167,0.5833 -0.3889,0.3889 -0.5833,0.8611 -0.5833,1.4167 0,0.5555 0.1944,1.0278 0.5833,1.4167 0.3889,0.3888 0.8611,0.5833 1.4167,0.5833 z m -9.3333,0 c 0.5555,0 1.0277,-0.1945 1.4166,-0.5833 0.3889,-0.3889 0.5834,-0.8612 0.5834,-1.4167 0,-0.5556 -0.1945,-1.0278 -0.5834,-1.4167 -0.3889,-0.3889 -0.8611,-0.5833 -1.4166,-0.5833 -0.5556,0 -1.0278,0.1944 -1.41671,0.5833 -0.38889,0.3889 -0.58333,0.8611 -0.58333,1.4167 0,0.5555 0.19444,1.0278 0.58333,1.4167 0.38891,0.3888 0.86111,0.5833 1.41671,0.5833 z m 0.6666,6 h 8 v -2 h -8 z m 4,8.6667 c -1.8444,0 -3.5778,-0.35 -5.2,-1.05 -1.6222,-0.7 -3.03331,-1.65 -4.23331,-2.85 -1.2,-1.2 -2.15,-2.6112 -2.85,-4.2334 -0.7,-1.6222 -1.05,-3.3555 -1.05,-5.2 0,-1.8444 0.35,-3.5778 1.05,-5.2 0.7,-1.6222 1.65,-3.03331 2.85,-4.23331 1.2,-1.2 2.61111,-2.15 4.23331,-2.85 1.6222,-0.7 3.3556,-1.05 5.2,-1.05 1.8445,0 3.5778,0.35 5.2,1.05 1.6222,0.7 3.0334,1.65 4.2334,2.85 1.2,1.2 2.15,2.61111 2.85,4.23331 0.7,1.6222 1.05,3.3556 1.05,5.2 0,1.8445 -0.35,3.5778 -1.05,5.2 -0.7,1.6222 -1.65,3.0334 -2.85,4.2334 -1.2,1.2 -2.6112,2.15 -4.2334,2.85 -1.6222,0.7 -3.3555,1.05 -5.2,1.05 z m 0,-2.6667 c 2.9778,0 5.5,-1.0333 7.5667,-3.1 2.0667,-2.0667 3.1,-4.5889 3.1,-7.5667 0,-2.9778 -1.0333,-5.5 -3.1,-7.56665 -2.0667,-2.06666 -4.5889,-3.1 -7.5667,-3.1 -2.9778,0 -5.5,1.03334 -7.56664,3.1 -2.06667,2.06665 -3.1,4.58885 -3.1,7.56665 0,2.9778 1.03333,5.5 3.1,7.5667 2.06664,2.0667 4.58884,3.1 7.56664,3.1 z",
    fill: "#757680",
    id: "path1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.d33ff7deade8d478c07b775ba86dfa6c.svg";
export { ForwardRef as ReactComponent };